import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import TweenMax from "gsap"
import {Signals} from "@/Imports"
import AddComponent from "@base/utils/AddComponent";
import {GlowFilter} from "@pixi/filter-glow";
import Platform from "@/utils/Platform";

export default class SplashScreenContainer extends BaseContainer {

    constructor(data) {
        super(data)
        this.init()
    }

    init() {
        this.background = new PIXI.Sprite(PIXI.Texture.from('background'))
        this.background.x = 100
        this.background.y = 200
        this.addChild(this.background)
        this.name = 'Splash Screen'

        this.addMainGraphics();
    }

    addMainGraphics() {

        const addElement = (name, container, position, scale = 1, pref = 'splashScreen') => {
            return AddComponent.addElement(name, container, position, pref, scale)
        }

        const addSpineAnimation = AddComponent.addSpineAnimation
        const addElementTextName = AddComponent.addElementTextName

        // addSpineAnimation('palms_fs', 'freegame_BG_Element_ani', this.background, [1325, 1290])
        // addElement('freebg_stones_left', this.background, [2100, 1510], 1, 'decor')
        // addElement('freebg_stones_back', this.background, [1670, 1350], 1, 'decor')
        // addSpineAnimation('tiki_bar_fs', 'freespins_tiki_bar_ani', this.background, [1315, 1360])

        this.splashContainer = new PIXI.Container()
        this.splashContainer.visible = false
        this.addChild(this.splashContainer)
        this.splashContainer.x = 850
        this.splashContainer.y = 690
        this.splashContainer.name = 'Splash Container'

        const filters = [new GlowFilter({ distance: 10, outerStrength: 2, color: 0x009977})];

        // AddComponent.addElementBitmapText( 'X21230', {font: {name: 'fontMultiplier', size: '150px'}, align:
        //  'center'},this.splashContainer, [100,-100], filters)


        addElement('rope_frame', this.splashContainer, [-200, 200])
        addElement('Tikiz_Logo', this.splashContainer, [300, 140])
        const board1 = addElement('board-01', this.splashContainer, [-40, 400])
        const board2 = addElement('board-02', this.splashContainer, [-40, 690])

        addElement('mask_splash', board1, [-100, -140])
        addElement('multipiler_symbol', board2, [735, -84])
      //  const winUpText = addElementTextName('splashScreen1', board1, [550, 240]) //'splashScreenYellow'
        AddComponent.addElementText('splashScreen1', 'splashScreenWhite', board1, [700, 120])
        AddComponent.addElementText('splashScreen2', 'splashScreenWhite', board2, [400, 120])
        //winUpText.text = winUpText.text + ' x6.000 ';

      //  addElement('100X', fishbowl, [70, 180])

        this.ContinueButton = new PIXI.AnimatedSprite([PIXI.Texture.from('splashScreen/nextButtonNormal'), PIXI.Texture.from('splashScreen/nextButtonOver'), PIXI.Texture.from('splashScreen/nextButtonDown')])
        this.ContinueButton.anchor.set(0.5)
        this.splashContainer.addChild(this.ContinueButton)
        this.ContinueButton.on('pointerover', () => {
            this.ContinueButton.gotoAndStop(1)
        })
        this.ContinueButton.on('pointerout', () => {
            this.ContinueButton.gotoAndStop(0)
        })
        this.ContinueButton.on('pointerdown', () => {
            this.ContinueButton.gotoAndStop(2)
        })
        this.ContinueButton.position.set(550, 1000)
        const caption = AddComponent.addElementText('splashScreenButtonPlay', 'splashScreenBtn', this.ContinueButton, [0, 0])
        this.ContinueButton.addChild(caption)

        Signals.loadingProgress.add(this.onPreloaderProgress, this)

        this.showContinue()
    }

    onPreloaderProgress = (progress) => {
        this.progress = progress
    }

    showContinue() {
        this.showContinueSplash()
    }

    showContinueSplash() {
        this.splashContainer.visible = true
        TweenMax.to(this.ContinueButton, 0.5, {
            alpha: 1, onComplete: () => {
                this.ContinueButton.interactive = true
                this.ContinueButton.on('pointerup', this.continueBtnClick, this)
            }
        })
    }

    continueBtnClick(e) {
        e.stopPropagation()
        this.off('pointerup', this.continueBtnClick, this)
        Signals.continueBtnClick.dispatch()
        this.interactive = false
        if ( Platform.isMobile()){
       //     Signals.requestFullScreen.dispatch({value: true})
        }
        this.destroy()
    }

}
